import { formatDate } from '../../utils';
import './templateSlider.scss';

// for templates slider
const templateSlide = i => `<div class="glide__slide">
  <div class="testimonial">
    <div class="testimonial__discipline"><span>Type of paper:</span> ${i.orderDiscipline}</div>
    <div class="testimonial__body">${i.body}</div>
    <div class="testimonial__footer">
      <div class="testimonial__pages"><span>Pages:</span> ${i.orderPages}</div>
      <div class="testimonial__date"><span>Date:</span> ${formatDate(i.createdAt)}</div>
      <div class="testimonial__id"><span>Customer ID:</span> ${i.customerId}XXX</div>
    </div>
  </div>
</div>`;

export default templateSlide;
